import { Component } from "@angular/core";

@Component({
    selector:'pin-create-caution-component',
    templateUrl:'./pin-create-caution.component.html',
    styleUrls:['./pin-create-caution.component.scss']
})
export class PINCreateCautionComponent {

}